module.exports = __webpack_public_path__ + "json/buildings-8.json?5cb4402a2f15c26c03612bb2251d270a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-8.json
// module id = 1727
// module chunks = 3